import { http } from './http';
import { ROUTES } from './config';
import type { Campaign, CampaignInput } from '../types/domain';

/** CampaignsController client (manager+) — promo codes that discount a quote server-side. */
export const campaignsApi = {
  list(): Promise<Campaign[]> {
    return http.get(ROUTES.campaigns);
  },

  get(id: string): Promise<Campaign> {
    return http.get(`${ROUTES.campaigns}/${id}`);
  },

  create(body: CampaignInput): Promise<{ id: string; code: string }> {
    return http.post(ROUTES.campaigns, body);
  },

  update(id: string, body: CampaignInput): Promise<void> {
    return http.put(`${ROUTES.campaigns}/${id}`, body);
  },

  remove(id: string): Promise<void> {
    return http.delete(`${ROUTES.campaigns}/${id}`);
  },
};
